<template>
  <div class="login-page bg-body-secondary">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'LoginLayout',
}
</script>
